<template>
    <div class="grid grid-rows-6 sm:grid-rows-6 md:grid-rows-6 lg:grid-rows-6 xl:grid-rows-6" @click="$emit('answer')">
      <div class="row-span-5 sm:row-span-5 md:row-span-4 lg:row-span-4 xl:row-span-4 grid grid-cols-4 border-blue-700 rounded-md" v-bind:class="[ chosen ? 'border-2 bg-blue-100 text-blue-600' : 'border bg-blue-200 hover:bg-blue-700 text-blue-800 hover:text-white hover:border-blue-300']">
          <div class="col-span-1 h-6 w-6 mx-2 mt-2 border rounded-sm" v-bind:class="[ chosen ? 'text-white bg-blue-400 border-blue-600' : 'text-blue-700 bg-blue-100 border-blue-800']">
              <span class="flex flex-col w-5.5 align-center justify-center text-center font-bold">{{option.keystroke}}</span><!--jOPYlp-->
          </div>
          <div class="col-start-4 flex flex-col h-6 w-6 mx-2 mt-2 align-center justify-center text-center font-bold">
            <div v-if="chosen">
              <svg class="block fill-current transition-colors duration-200 ease-in-out" height="13" width="16"><path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z"></path></svg>
            </div>
          </div>
          <div class="col-span-4 mx-5 sm:mx-10 md:mx-10 lg:mx-10 xl:mx-10 mb-2" @mouseover="hover = true" @mouseleave="hover = false" :class="{ 'img-hover': hover }">
            <img :src="option.value.displayUrl">
          </div>
          <p class="col-span-4 pt-1 px-2 pb-2 text-center">{{option.label}}</p>
      </div>
      <div class="row-start-6 sm:row-start-6 md:row-start-5 lg:row-start-5 xl:row-start-5 row-span-1 sm:row-span-1 md:row-span-2 lg:row-span-2 xl:row-span-2">
        <button class="grid grid-cols-5 mt-2 w-full" @click="$emit('utterance', option.label)"><svg role="img" class="col-start-3" width="28px" height="28px" viewBox="0 0 24 24" stroke="#215e4e" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#215e4e"> <title>Read question text</title> <path d="M13 5v14l-5-4H3V9h5z"/> <path stroke-linecap="round" d="M13 14c1.5-1 1.5-3 0-4"/> <path d="M16 16C18.0858253 13.9141747 18.0858253 10.0858253 16 8M18 19C21.98552 15.01448 22.0076803 9.00768033 18 5"/></svg></button>
      </div>
    </div>
</template>

<script>
export default {
  props: ['chosen', 'option'],
  data() {
    return {
      hover: false,
    };
  }
}
</script>
<style scoped>
.img-hover {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);
}
</style>